function fromEntries(iterable) {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
}
const isValidHexColor = (color) => color && /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color);
const getValidHexColor = (color) => color && isValidHexColor(color) ? color : void 0;
export {
  fromEntries,
  getValidHexColor
};
//# sourceMappingURL=utils.js.map
